import axios from "axios";

export default axios.create({
   baseURL: "https://musclesisters-api-live4.musclesistersapp.com/api/v5/",
 // baseURL: "https://musclesisters-qa-api.musclesistersapp.com/api/v4",
});
